import { Modal } from "@mui/material";
import React, { useEffect, useMemo, useRef, useState } from "react"
import { useWidgetDndContextData } from "src/context/WidgetDndContext";
import SortAndFilter from "./SortAndFilter";
import { COMMON_LAYOUT_TYPE } from "../ListPresentation/components/Testimonials/Constants";
import FilterHeading from "./Component/FilterHeading";
import { SortList } from "src/utils/constants";
import { getFilterOptionStyle } from "./utils";
import { useSelector } from "src/redux";
import { filterIcon } from "./svg/svgList";
const SortAndFilterMobile = (props) => {
  const {selectedFilterInfo} = props
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [showSortInMobile, setShowSortInMobile] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [showRef, setShowRef] = useState(false)
  const {
    widgetContextState: { isBuilder, pageStyle, globalStyle },
  } = useWidgetDndContextData();
  const { sortType, store, headerRef } = useSelector(
    (state) => ({
      sortType: state.catalogReducer.sortType,
      store: state.storeReducer?.store,
      headerRef: state.commonReducer?.headerRef,
    })
  );
  const mobileRef = useRef(null);
  const themeColor = isBuilder ? (globalStyle?.color?.themeColor || store?.theme?.colors?.primary_color || '') : store?.theme?.colors?.primary_color
  const mobileLayout = pageStyle?.sortAndFilter?.layout_mobile;
  const isLayout1 = mobileLayout === COMMON_LAYOUT_TYPE.ONE

  useEffect(() => {
    const container = isBuilder ? props.containerRef?.current : window;
    const target = mobileRef.current;

    const handleScroll = () => {
      if (!container || !target) return;
      const targetRect = target.getBoundingClientRect();
      if (targetRect.top < 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, [showRef, isFilterActive]);

  useEffect(() => {
     setShowRef(true);
  }, [])

  const selectedFilterCount = useMemo(() => {
      let count = 0;
      Object.keys((selectedFilterInfo || {}))?.map((key) => {
         count = count + selectedFilterInfo[key]?.length;
      })
      return count;
  }, [selectedFilterInfo])

  function handleClick(name) {
    if (name === 'Sort' || showSortInMobile) {
      setShowSortInMobile(!showSortInMobile);
    }
    setIsFilterActive(!isFilterActive)
  }

  function getStyleByLayout() {
    let style: any = { margin: '0 -16px' }
    if (isBuilder) {
      style = {
        ...style,
        width: '360px'
      }
    }
    switch (mobileLayout) {
      case COMMON_LAYOUT_TYPE.ONE:
        return {
          ...style,
          top: -20,
          borderRadius: '0px',
          borderBottom: '1px solid #111C361F'
        }
      case COMMON_LAYOUT_TYPE.TWO:
        if (isBuilder) {
          return {
            ...style,
            bottom: 32,
            borderRadius: '0 0 8px 8px',
            borderTop: '1px solid #111C361F'
          }
        }
        else {
          return {
            ...style,
            bottom: 0,
            borderTop: '1px solid #111C361F'
          }
        }
      default:
        return {}
    }
  }

  function renderButton(name, sprite, className = '', bgColor = '') {
    return (
      <div style={{ background: bgColor }} onClick={() => handleClick(name)} className={`tw-flex tw-items-center  tw-gap-[8px] tw-cursor-pointer
       tw-border tw-border-solid tw-border-[#111C361F] tw-px-[12px] tw-py-[12px] ${className}`}>
        {sprite && <div className={`wb-sprite ${sprite}`}></div>}
        <div className={`tw-text-[14px] tw-font-normal tw-text-newBlack ${bgColor ? 'tw-text-white' : ''}`}>{name}</div>
      </div>
    )
  }

  function renderSortOption() {
    return (
      <div className="tw-h-max tw-w-[100%]">
        <div className="tw-w-[100%] tw-flex tw-items-center tw-justify-between tw-p-[16px] tw-border-b tw-border-solid tw-border-[#111C361F] ">
          <div style={{ color: pageStyle?.sortAndFilter?.title_color }} className="tw-text-[16px] tw-font-normal">{'Sort By'}</div>
          <div onClick={() => handleClick('Sort')} className="wb-sprite ic-cross-black"></div>
        </div>
        {
          <div className="tw-px-[16px] tw-py-[22px] tw-flex tw-flex-col tw-gap-[20px]">
            {SortList?.map((item, index) => {
              const isSelected = sortType === item.type;
              return (
                <div className="tw-flex tw-items-center tw-gap-[10px]" key={index}>
                  <div onClick={(e) => props?.handleSortItemClick(e, item)} style={{ border: `1px solid ${isSelected ? themeColor : '#000000'}` }} className="tw-rounded-[50%] tw-relative tw-flex tw-justify-center tw-items-center tw-w-[18px] tw-h-[18px]">
                    {
                      isSelected && (
                        <div style={{ background: themeColor }} className="tw-absolute tw-w-[12px] tw-h-[12px] tw-rounded-[50%] "></div>
                      )
                    }
                  </div>
                  <div style={{ ...getFilterOptionStyle(pageStyle, true) }} className={isSelected ? '!tw-font-semibold' : ''}>
                    {item?.name}
                  </div>
                </div>
              )
            })}
          </div>
        }
      </div>
    )
  }

  function renderFilterForMobile() {
    return (
      <div className="tw-relative tw-h-[100%] tw-w-[100%] tw-bg-white">
        <SortAndFilter {...props} />
        <div className="tw-w-[100%] tw-flex tw-items-center tw-justify-between  tw-absolute tw-bottom-0 tw-px-[16px] tw-py-[12px] tw-border-t tw-border-solid tw-border-[#111C361F] tw-bg-white">
          <div onClick={() => handleClick('Cancel')} className="tw-px-[16px] tw-py-[12px] tw-w-[128px] tw-flex tw-items-center
           tw-cursor-pointer tw-gap-[8px] tw-justify-center tw-border tw-border-solid tw-border-[#111C361F]">
            <span className="tw-text-[14px] tw-font-normal tw-text-newBlack">{'Cancel'}</span>
          </div>
          <div onClick={() => handleClick('Apply')} className="tw-px-[16px] tw-py-[12px] tw-w-[128px] tw-flex tw-cursor-pointer 
          tw-items-center tw-gap-[8px] tw-justify-center tw-bg-[#111C36]">
            <span className="tw-text-[14px] tw-font-normal tw-text-white">{'Apply filters'}</span>
          </div>
        </div>
      </div>
    )
  }

  function renderSortForMobile() {
    return (
      <div className="tw-relative tw-h-[100%] tw-w-[100%]">
        <div className="tw-absolute tw-bottom-0 tw-w-[100%] tw-bg-white tw-flex tw-flex-col">
          {renderSortOption()}
          <div className="tw-w-[100%] tw-flex tw-items-center tw-justify-end tw-border-t tw-border-solid tw-border-[#111C361F] tw-bg-white">
            <div className="tw-w-[50%]">
              {renderButton('Cancel', '', 'tw-text-[#111c36] tw-justify-center')}
            </div>
            <div className="tw-w-[50%]">
              {renderButton('Apply', '', ' tw-justify-center tw-text-white ', themeColor)}
            </div>
          </div>
        </div>
      </div>
    )
  }

  function renderFilters() {
    return (
      !isFilterActive && <div ref={mobileRef} style={{ ...getStyleByLayout()}} className={`${isLayout1 ? '' : 'tw-fixed'} tw-z-10 tw-px-[16px] tw-py-[8px] tw-bg-white
     tw-flex tw-items-center tw-justify-between tw-gap-[20px]
     `}>
        <div onClick={() => handleClick('Filter')} className="tw-w-[50%] tw-px-[16px] tw-py-[12px] tw-flex tw-items-center  tw-cursor-pointer tw-gap-[8px] tw-justify-center">
          <span className="">{filterIcon()}</span>
          <span className="tw-text-[14px] tw-font-normal tw-text-newBlack">{`Filters ${selectedFilterCount > 0 ? `(${selectedFilterCount})` : ''}`}</span>
        </div>
        <div className="tw-h-[28px] tw-w-[1px] tw-bg-[#111C361F]"></div>
        <div onClick={() => handleClick('Sort')} className="tw-w-[50%] tw-px-[16px] tw-py-[12px] tw-flex tw-cursor-pointer tw-items-center tw-gap-[8px] tw-justify-center">
          <span className="wb-sprite sort-filter"></span>
          <span className="tw-text-[14px] tw-font-normal tw-text-newBlack">{'Sort'}</span>
        </div>
      </div>
    )
  }

  function scrollStateFilter() {
    return (
      !isFilterActive && <div style={{ ...getStyleByLayout(), top: (isBuilder ? headerRef?.current?.clientHeight + 66 : 0), width: isBuilder ? mobileRef?.current?.clientWidth : '100%'}} className={`${isLayout1 ? '' : 'tw-fixed'} tw-z-10 tw-px-[16px] tw-py-[8px] tw-bg-white
     tw-flex tw-items-center tw-justify-between tw-gap-[20px] ${isSticky ? 'tw-fixed ' : ''}
     `}>
        <div onClick={() => handleClick('Filter')} className="tw-w-[132px] tw-px-[16px] tw-py-[12px] tw-flex tw-items-center tw-cursor-pointer tw-gap-[8px] tw-justify-center">
          <span className="">{filterIcon()}</span>
          <span className="tw-text-[14px] tw-font-normal tw-text-newBlack">{'Filter'}</span>
        </div>
        <div className="tw-h-[28px] tw-w-[1px] tw-bg-[#111C361F]"></div>
        <div onClick={() => handleClick('Sort')} className="tw-w-[132px] tw-px-[16px] tw-py-[12px] tw-flex tw-cursor-pointer tw-items-center tw-gap-[8px] tw-justify-center">
          <span className="wb-sprite sort-filter"></span>
          <span className="tw-text-[14px] tw-font-normal tw-text-newBlack">{'Sort'}</span>
        </div>
      </div>
    )
  }

  return (
    <div className="tw-relative">
      <div className="tw-flex tw-flex-col">
        <div >
          <FilterHeading selectedCatCol={props?.selectedCatCol} isCollection={props.isCollection} />
        </div>
        { 
        <div>
          {renderFilters()}
          {isSticky && scrollStateFilter()}
        </div>
        }
      </div>
      <Modal
        open={isFilterActive}
        style={{ bottom: 0 }}
        onClose={() => setIsFilterActive(false)}
      >
        {showSortInMobile ? renderSortForMobile() : renderFilterForMobile()}
      </Modal>
    </div>
  )
}

export default SortAndFilterMobile